import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { OsUpdate } from '@rocksoft/osupdates-sdk';

export interface AllowedOsUpdate extends OsUpdate {
  deviceId: string;
}

export type AllowedOsUpdateState = EntityState<AllowedOsUpdate>;

export function selectId(allowedUpdate: AllowedOsUpdate) {
  return `${allowedUpdate.deviceId}-${allowedUpdate.productKey}-${allowedUpdate.version}`;
}

export const adapter: EntityAdapter<AllowedOsUpdate> = createEntityAdapter<AllowedOsUpdate>({
  selectId,
});

export const initialState: AllowedOsUpdateState = adapter.getInitialState();
